import * as React from "react";

import { appUserSlice, loadState, LOCALSTORE_KEY } from "../../../api/slices/appUser";
import { selectAppUser, useAppDispatch, useAppSelector } from "../../store";

export const AppUserStateListener: React.FC = () => {
  const dispatch = useAppDispatch();
  const appUser = useAppSelector(selectAppUser);
  React.useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === LOCALSTORE_KEY && event.newValue !== appUser.accessTokenExpiry) {
        dispatch(appUserSlice.actions.setTokens(loadState()));
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [appUser.accessTokenExpiry, dispatch]);
  return <></>;
};
